import { AlertTriangle } from 'lucide-react'
import PropTypes from 'prop-types'

import { Button } from '@/components/elements/button'
import { Card, CardContent } from '@/components/elements/card'

/**
 * LoadError
 *
 * What a screen shows in place of a list or a figure when the request failed.
 *
 * Kept deliberately separate from the empty state. "There is nothing here" and
 * "we could not find out" are different sentences, and rendering the first for
 * the second tells somebody a table is empty when nobody knows what is in it.
 *
 * @param {object} props
 * @param {string} props.message - What could not be loaded
 * @param {string} [props.detail] - A second line, when the distinction matters
 * @param {Function} [props.onRetry] - Retries the request
 * @returns {import('react').JSX.Element} The failure card
 */
export const LoadError = ({ message, detail = undefined, onRetry = undefined }) => (
  <Card>
    <CardContent className="flex flex-col items-center gap-3 py-10 text-center">
      <AlertTriangle className="text-destructive size-8" />
      <div>
        <p className="font-medium">{message}</p>
        {detail && <p className="text-muted-foreground text-sm">{detail}</p>}
      </div>
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          Try again
        </Button>
      )}
    </CardContent>
  </Card>
)

LoadError.propTypes = {
  message: PropTypes.string.isRequired,
  detail: PropTypes.string,
  onRetry: PropTypes.func,
}

export default LoadError
